import { _ as __assign } from '../colors.module-d9df1b1f.js';
import { c as commonStyles } from '../common.module-a1e46866.js';
import React from 'react';
import 'classnames';
import { Title as Title$1 } from './component.js';

var styles = {"styrene-xlarge":"typography__styrene-xlarge_csqb7","styrene-large":"typography__styrene-large_csqb7","styrene-medium":"typography__styrene-medium_csqb7","styrene-small":"typography__styrene-small_csqb7","styrene-xsmall":"typography__styrene-xsmall_csqb7","system-xlarge":"typography__system-xlarge_csqb7","system-large":"typography__system-large_csqb7","system-medium":"typography__system-medium_csqb7","system-small":"typography__system-small_csqb7","system-xsmall":"typography__system-xsmall_csqb7","margins-xlarge":"typography__margins-xlarge_csqb7","margins-large":"typography__margins-large_csqb7","margins-medium":"typography__margins-medium_csqb7","margins-small":"typography__margins-small_csqb7","margins-xsmall":"typography__margins-xsmall_csqb7","bold":"typography__bold_csqb7","medium":"typography__medium_csqb7","regular":"typography__regular_csqb7"};
require('./index.css');

var Title = function (props) {
    /**
     * Если поменять Object.assign на деструктуризацию, то упадут тесты.
     * Видимо, это особенность работы jest и css-modules.
     */
    return React.createElement(Title$1, __assign({}, props, { styles: Object.assign(commonStyles, styles) }));
};

export { Title };
